/**
 * Checkbox — 체크박스 컴포넌트
 */

import { cn } from '../../lib/cn.js'
import styles from './Checkbox.module.css'

export interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
  className?: string
}

export function Checkbox({
  checked,
  onChange,
  label,
  disabled = false,
  className,
}: CheckboxProps) {
  return (
    <label className={cn(styles.wrapper, disabled && styles.disabled, className)}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => !disabled && onChange(e.target.checked)}
        disabled={disabled}
        className={styles.input}
      />
      {label && <span className={styles.label}>{label}</span>}
    </label>
  )
}
